export const THEMES = [
  { id: "standard", label: "Стандартная", swatch: "linear-gradient(135deg, #0a0d16 40%, #0064f4)" },
  { id: "girly", label: "Девичья", swatch: "linear-gradient(135deg, #ffe0ee 40%, #ef4d9d)" },
  { id: "mens", label: "Мужская", swatch: "linear-gradient(135deg, #14171c 40%, #4a86c2)" },
];

export const getStoredTheme = () => localStorage.getItem("lifeos-theme") || "standard";

export function applyTheme(t) {
  if (t === "standard") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", t);
  localStorage.setItem("lifeos-theme", t);
  window.dispatchEvent(new CustomEvent("theme-change", { detail: t }));
}
